window.addEventListener("load", function () {    
    // Handle hover and click for flow-diemdanh-item
    $(".flow-diemdanh-item").on("mouseenter click", function (e) {
        $(".flow-diemdanh li").css("z-index", "");
        $(this).closest("li").css("z-index", "1");
    });
    
    // Function to update active/off classes based on tongdiem
    function updateFlowDiemdanhClasses() {
        var tongdiem = parseInt($(".tongdiem").val()) || 0;
        
        $(".flow-diemdanh .flow-date").each(function(index) {
            var flowDate = parseInt($(this).text()) || 0;
            var $li = $(this).closest("li");
            var bepItemIndex = index + 1;
            var $bepItem = $(".tree-item-" + bepItemIndex);
            var $btnNhan = $li.find(".btn-nhan");
            
            $li.removeClass("off");
            $bepItem.removeClass("off");
            
            if (tongdiem < flowDate) {
                $li.addClass("off");
                $bepItem.addClass("off");
            }
            
            // Update button text based on received class
            if ($li.hasClass("received")) {
                $btnNhan.text("Đã nhận");
            } else {
                $btnNhan.text("Nhận");
            }
        });
        if (tongdiem < 150) {
            //$(".flow-diemdanh").css("--progress-width", "160px");
            $(".flow-diemdanh").addClass("status-1");
        }
        else if (tongdiem >= 150 && tongdiem < 470) {
            $(".flow-diemdanh").css("--progress-width", "250px");
            $(".flow-diemdanh").addClass("status-2");
        }
        else if (tongdiem >= 470 && tongdiem < 870) {
            $(".flow-diemdanh").css("--progress-width", "500px");
            $(".flow-diemdanh").addClass("status-3");
        }
        else if (tongdiem >= 870 && tongdiem < 1270) {
            $(".flow-diemdanh").css("--progress-width", "810px");
            $(".flow-diemdanh").addClass("status-4");
        }
        else if (tongdiem >= 1270) {
            $(".flow-diemdanh").css("--progress-width", "100%");
            $(".flow-diemdanh").addClass("status-5");
        }
    }
    
    // Call on page load
    updateFlowDiemdanhClasses();
    
    // Optional: Watch for changes in tongdiem value (if it changes dynamically)
    // Uncomment if tongdiem value can change after page load
    // var tongdiemInput = $(".tongdiem");
    // if (tongdiemInput.length) {
    //     var observer = new MutationObserver(function(mutations) {
    //         updateFlowDiemdanhClasses();
    //     });
    //     observer.observe(tongdiemInput[0], { attributes: true, attributeFilter: ['value'] });
    // }

});